export const creatureIntelligence = [
  {
    description: "Animal-like",
    INT: "6-(1D4)",
  },
  {
    description: "Human-like",
    INT: "6+(1D8)",
  },
  {
    description: "Above human",
    INT: "12+(1D8)",
  },
];
